import type { GrowTimeout } from './grow'

/** Default enter duration (ms). Matches MUI's standard screen duration. */
const DEFAULT_ENTER_MS = 225
/** Default exit duration (ms). Matches MUI's standard screen duration. */
const DEFAULT_EXIT_MS = 195

export const resolveDurationMs = (
  timeout: GrowTimeout | undefined,
  direction: 'enter' | 'exit',
) => {
  if (typeof timeout === 'number') {
    return timeout
  }
  const fallback = direction === 'enter' ? DEFAULT_ENTER_MS : DEFAULT_EXIT_MS

  return timeout?.[direction] ?? fallback
}
